/**
 * ActiveGridStore — holds a reference to the currently focused GridApi and the
 * active module name. Used by the global LayoutManagerDialog (opened from MenuBar)
 * to capture/apply column state without prop-drilling.
 */
import { create } from "zustand";
import type { GridApi } from "ag-grid-community";

interface ActiveGridState {
  gridApi: GridApi | null;
  activeModule: string;
  setGrid: (api: GridApi | null, module: string) => void;
}

export const useActiveGridStore = create<ActiveGridState>((set) => ({
  gridApi: null,
  activeModule: "dashboard",
  setGrid: (api, module) => set({ gridApi: api, activeModule: module }),
}));
